<template>
  <div class="row-scroll-wrapper" :style="customStyle">
    <ul class="row-scroll-items-nav">
      <slot></slot>
      <li class="padding-right-li"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'row-scroll',
  props: {
    height: {
      type: String,
      default: '236px',
    },
    data: Object,
    background: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      ready: false,
      noDrag: false,
    }
  },
  computed: {
    customStyle() {
      return [{ height: this.height }, { background: this.background }]
    },
  },
  methods: {
    rowScrollItemCreated() {
      if (!this.ready) return

      clearTimeout(this.reInitTimer)
      this.reInitTimer = setTimeout(() => {
        this.reInitPages()
      }, 100)
    },
    rowScrollItemDestroyed() {
      if (!this.ready) return

      clearTimeout(this.reInitTimer)
      this.reInitTimer = setTimeout(() => {
        this.reInitPages()
      }, 100)
    },
    reInitPages() {
      var children = this.$children
      this.noDrag = children.length === 1 && this.noDragWhenSingle
    },
  },
  mounted() {
    this.ready = true
    this.reInitPages()
  },
}
</script>

<style lang="less" scoped>
.row-scroll-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  height: 236px;
  &::-webkit-scrollbar {
    display: none;
  }
  ul {
    margin: 0;
    padding-left: 15px;
    list-style: none;
    // overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    &::before,
    &::after {
      content: '';
      display: table;
    }
    &::after {
      clear: both;
    }
  }
  a {
    text-decoration: none;
  }
  .row-scroll-items-nav {
    display: flex;
    justify-content: flex-start;
    position: relative;
    width: 100%;
    .padding-right-li {
      width: 5px;
      cursor: pointer;
      clear: both;
      &::after {
        content: '.';
        visibility: hidden;
      }
    }
    .row-scroll-item {
      position: relative;
      margin-right: 10px;
    }
  }
}
</style>
